'use strict';

const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const REGEX_CNPJ_ALFANUMERICO = /^[0-9A-Z]{12}[0-9]{2}$/;
const REGEX_CPF = /^[0-9]{11}$/;

function normalizarCpfCnpj(documento) {
    if (documento === null || documento === undefined) return '';
    return String(documento).trim().toUpperCase().replace(/[^0-9A-Z]/g, '');
}

function normalizarCnpj(cnpj) {
    let normalizado = normalizarCpfCnpj(cnpj);
    if (normalizado.length === 0) return normalizado;
    while (normalizado.length < 14) normalizado = '0' + normalizado;
    return normalizado;
}

function calcularDigito(base, pesos) {
    let soma = 0;
    for (let i = 0; i < pesos.length; i++) {
        soma += (base.charCodeAt(i) - 48) * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
}

function isCnpjValido(cnpj) {
    const normalizado = normalizarCpfCnpj(cnpj);

    if (normalizado.length !== 14 || !REGEX_CNPJ_ALFANUMERICO.test(normalizado)) return false;

    if (/^(.)\1+$/.test(normalizado)) return false;

    const base = normalizado.substring(0, 12);
    const dv1 = calcularDigito(base, PESOS_DV1);
    const dv2 = calcularDigito(base + dv1, PESOS_DV2);

    return normalizado.charCodeAt(12) - 48 === dv1 && normalizado.charCodeAt(13) - 48 === dv2;
}

function formatarCnpj(cnpj) {
    const normalizado = normalizarCnpj(cnpj);
    if (normalizado.length !== 14) return normalizado;

    return normalizado.substring(0, 2) + '.' +
        normalizado.substring(2, 5) + '.' +
        normalizado.substring(5, 8) + '/' +
        normalizado.substring(8, 12) + '-' +
        normalizado.substring(12, 14);
}

function formatarCpf(cpf) {
    let normalizado = normalizarCpfCnpj(cpf);
    if (normalizado.length === 0) return '';
    while (normalizado.length < 11) normalizado = '0' + normalizado;
    if (!REGEX_CPF.test(normalizado)) return normalizado;

    return normalizado.substring(0, 3) + '.' +
        normalizado.substring(3, 6) + '.' +
        normalizado.substring(6, 9) + '-' +
        normalizado.substring(9, 11);
}

function formatarCpfCnpj(documento) {
    const normalizado = normalizarCpfCnpj(documento);
    if (normalizado.length === 0) return '';

    if (normalizado.length > 11 || /[A-Z]/.test(normalizado)) return formatarCnpj(normalizado);

    return formatarCpf(normalizado);
}

const TOKENS_MASCARA_CNPJ = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/, transform: function (v) { return v.toLocaleUpperCase(); } }
};

const MASCARA_CNPJ = { mask: 'XX.XXX.XXX/XXXX-##', tokens: TOKENS_MASCARA_CNPJ };

module.exports = {
    normalizarCpfCnpj: normalizarCpfCnpj,
    normalizarCnpj: normalizarCnpj,
    isCnpjValido: isCnpjValido,
    formatarCnpj: formatarCnpj,
    formatarCpf: formatarCpf,
    formatarCpfCnpj: formatarCpfCnpj,
    TOKENS_MASCARA_CNPJ: TOKENS_MASCARA_CNPJ,
    MASCARA_CNPJ: MASCARA_CNPJ
};
